import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * A custom element that displays the product's eyebrow line and selected
 * variant option (e.g. flavor) as a large heading. Listens for variant
 * update events (dispatched by variant-picker) and swaps in the matching
 * fragment from the fetched page, the same pattern product-price.js uses.
 */
class ProductFlavorTitle extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * @param {import('@shopify/events').ProductSelectEvent} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (detail.productId && detail.productId !== this.dataset.productId) return;

        const newTitle = detail.html.querySelector(`product-flavor-title[data-block-id="${this.dataset.blockId}"]`);
        if (!newTitle) return;

        const { titleContainer } = this.refs;
        const newTitleContainer = newTitle.querySelector('[ref="titleContainer"]');

        if (titleContainer && newTitleContainer) {
          titleContainer.replaceWith(newTitleContainer);
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-flavor-title] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-flavor-title')) {
  customElements.define('product-flavor-title', ProductFlavorTitle);
}
